import { defineBlocksWithJsonArray } from 'blockly/core';

import {
  BEGINNER_DISPLAY_BLOCK_STYLE,
  displayCursorFields,
  displayTextValueInput,
} from './display-helpers.js';
import { registerBeginnerLcdConfigureBlock } from './lcd-configure-block.js';

/**
 * Beginner LCD (16x2) statement blocks.
 * One LCD only — no device dropdown. Configure LCD handles Parallel / I2C UI.
 */
const lcdBlockDefinitions = [
  {
    type: 'beginner_lcd_display_text',
    message0: 'display text %1',
    args0: [displayTextValueInput()],
    previousStatement: null,
    nextStatement: null,
    style: BEGINNER_DISPLAY_BLOCK_STYLE,
    tooltip: 'Shows text on the LCD.',
    helpUrl: '',
  },
  {
    type: 'beginner_lcd_clear',
    message0: 'clear display',
    previousStatement: null,
    nextStatement: null,
    style: BEGINNER_DISPLAY_BLOCK_STYLE,
    tooltip: 'Clears all text from the LCD.',
    helpUrl: '',
  },
  {
    type: 'beginner_lcd_set_cursor',
    message0: 'set cursor column %1 row %2',
    args0: displayCursorFields(),
    previousStatement: null,
    nextStatement: null,
    style: BEGINNER_DISPLAY_BLOCK_STYLE,
    tooltip: 'Moves the LCD cursor to a column and row.',
    helpUrl: '',
  },
  {
    type: 'beginner_lcd_scroll_left',
    message0: 'scroll left',
    previousStatement: null,
    nextStatement: null,
    style: BEGINNER_DISPLAY_BLOCK_STYLE,
    tooltip: 'Scrolls LCD text one step to the left.',
    helpUrl: '',
  },
  {
    type: 'beginner_lcd_scroll_right',
    message0: 'scroll right',
    previousStatement: null,
    nextStatement: null,
    style: BEGINNER_DISPLAY_BLOCK_STYLE,
    tooltip: 'Scrolls LCD text one step to the right.',
    helpUrl: '',
  },
];

export function registerBeginnerLcdBlocks(): void {
  registerBeginnerLcdConfigureBlock();
  defineBlocksWithJsonArray(lcdBlockDefinitions);
}
